import styled from 'styled-components';

export const MainMethodologiesStyles = styled.div``;
